import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Service
import {
    CreateContent,
    GetContentById,
    UpdateContent,
} from "./services/Services.js"
import {
    SavePageSetting,
    SearchPageSetting,
    UpdatePageSetting,
} from "../../services/api/module/PageSetting.js"
import CardPieceTopic from "./components/CardPieceTopic"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `contact-us`
const _pageName = `Contact Us`
const _routePermission = `contact-us:page-setting`

const DEF_SORT = [1,2,3,4,5,6]

const ContactUsTemplate = ({
    pageName = "",
    pageView = "create",
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext)

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? "TH"
    const qMainId = 1
    const navigate = useNavigate()

    const [list, setList] = useState([
        { id: 1, name: 'Item 1' },
        { id: 2, name: 'Item 2' },
        { id: 3, name: 'Item 3' },
        { id: 4, name: 'Item 4' },
        { id: 5, name: 'Item 5' },
    ]);

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    const [cardSeq, setCardSeq] = useState(DEF_SORT)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        contentName: Yup.string().max(255).required("Please Enter Site Name"),
        slug: Yup.string().max(255).required("Please Enter Slug"),
        contentDetail: Yup.string().required("Please Enter Detail"),

        // contentTopicKey: Yup.string().required("Please Enter Detail"),
        contentTopic1Label: Yup.string().required("Please Enter Topic 1 Label"),
        contentTopic1EmailList: Yup.string().required("Please Enter Topic 1 Email List"),

        contentTopic2Label: Yup.string(),
        contentTopic2EmailList: Yup.string(),

        contentTopic3Label: Yup.string(),
        contentTopic3EmailList: Yup.string(),

        contentTopic4Label: Yup.string(),
        contentTopic4EmailList: Yup.string(),

        contentTopic5Label: Yup.string(),
        contentTopic5EmailList: Yup.string(),

        contentTopic6Label: Yup.string(),
        contentTopic6EmailList: Yup.string(),

        bannerDesktop: Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner Desktop",
            (value) => value && Object.keys(value).length > 0
        ).required("Please Upload Banner Desktop"),

        bannerMobile: Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner Mobile",
            (value) => value && Object.keys(value).length > 0
        ).required("Please Upload Banner Mobile"),

        contentSeoTitle: Yup.string(),
        contentSeoKeyword: Yup.string().max(1024),
        contentSeoDescription: Yup.string().max(1024),

        contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
        contentStatus: Yup.string().max(100).required("Please Enter Display"),
    })

    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] =
        useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        contentName: "",
        contentDetail: "",

        contentTopic1Label:     "",
        contentTopic1EmailList: "",
        contentTopic2Label:     "",
        contentTopic2EmailList: "",
        contentTopic3Label:     "",
        contentTopic3EmailList: "",
        contentTopic4Label:     "",
        contentTopic4EmailList: "",
        contentTopic5Label:     "",
        contentTopic5EmailList: "",
        contentTopic6Label:     "",
        contentTopic6EmailList: "",

        bannerDesktop: {},
        bannerMobile: {},
        socialLink: [],

        contentSeoTitle: "",
        contentSeoKeyword: "",
        contentSeoDescription: "",
        contentUpdateDate: moment().format("YYYY-MM-DD"),
        contentStatus: "active",

        slug: "",
        contentPageName: "",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
            const valueSort = fnSortCardSeq(cardSeq,
                [
                    {
                        contentTopicLabel:     values.contentTopic1Label,
                        contentTopicEmailList: values.contentTopic1EmailList,
                    },
                    {
                        contentTopicLabel:     values.contentTopic2Label,
                        contentTopicEmailList: values.contentTopic2EmailList,
                    },
                    {
                        contentTopicLabel:     values.contentTopic3Label,
                        contentTopicEmailList: values.contentTopic3EmailList,
                    },
                    {
                        contentTopicLabel:     values.contentTopic4Label,
                        contentTopicEmailList: values.contentTopic4EmailList,
                    },
                    {
                        contentTopicLabel:     values.contentTopic5Label,
                        contentTopicEmailList: values.contentTopic5EmailList,
                    },
                    {
                        contentTopicLabel:     values.contentTopic6Label,
                        contentTopicEmailList: values.contentTopic6EmailList,
                    },
                ]
            )

            const payload = {
                id: qMainId,
                contentId: values.contentId ? values.contentId : undefined,
                langId: qLang,
                slug: values.slug.replace(/-+$/, ''),
                contentName: values.contentName,
                contentDetail: values.contentDetail,
                // contentTopicKey: values.contentTopicKey,
                contentTopic1Label:     valueSort[0]?.contentTopicLabel,
                contentTopic1EmailList: valueSort[0]?.contentTopicEmailList,

                contentTopic2Label:     valueSort[1]?.contentTopicLabel,
                contentTopic2EmailList: valueSort[1]?.contentTopicEmailList,

                contentTopic3Label:     valueSort[2]?.contentTopicLabel,
                contentTopic3EmailList: valueSort[2]?.contentTopicEmailList,

                contentTopic4Label:     valueSort[3]?.contentTopicLabel,
                contentTopic4EmailList: valueSort[3]?.contentTopicEmailList,

                contentTopic5Label:     valueSort[4]?.contentTopicLabel,
                contentTopic5EmailList: valueSort[4]?.contentTopicEmailList,

                contentTopic6Label:     valueSort[5]?.contentTopicLabel,
                contentTopic6EmailList: valueSort[5]?.contentTopicEmailList,

                contentSeoTitle: values.contentSeoTitle,
                contentSeoKeyword: values.contentSeoKeyword,
                contentSeoDescription: values.contentSeoDescription,
                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,

                attachmentData: {
                    
                },

                contentAttachmentData: {
                    socialLink: values.socialLink,
                    bannerDesktop: values.bannerDesktop,
                    bannerMobile: values.bannerMobile,
                },
            }

            const pageSettingRoute = {
                contentPageName: values.contentName,
                slug: values.slug.replace(/-+$/, ''),
                componentKey: componentKey,
                attachmentData: {
                    
                },

                contentAttachmentData: {
                    bannerDesktop: values.bannerDesktop,
                    bannerMobile: values.bannerMobile,
                },

                contentSeoTitle: values.contentSeoTitle,
                contentSeoKeyword: values.contentSeoKeyword,
                contentSeoDescription: values.contentSeoDescription,
                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,
            }
            console.log("🚀 ~ onSave ~ payload:", payload)

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContent(payload, pageSettingRoute)
            } else {
                API.fetchCreateContent(payload, pageSettingRoute)
            }
        },
    })

    const fnSortCardSeq = (seqNoSort = [], valueList = []) => {
        let newValueList = []
        for (let no of seqNoSort) {
            console.log('no', no)
            const valueWithNo = valueList.find((item,i) => (i + 1)  == no)
            newValueList.push(valueWithNo)
        }

        return newValueList
    }

    // Handle the end of sorting to update the card sequence
    const handleSortEnd = (newSeq) => {
        setCardSeq(newSeq);  // Update the cardSeq state
        validation.setFieldValue("cardSeq", newSeq);  // Synchronize with Formik
    };

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        // validation.setFieldValue("contentId", resData?.contentId ?? "")
        validation.setFieldValue("contentName", resData?.contentName ?? "")
        validation.setFieldValue("slug", resData?.slug ?? "")
        validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")

        // validation.setFieldValue("contentTopicKey", resData?.contentTopicKey ?? "")
        validation.setFieldValue("contentTopic1Label", resData?.contentTopic1Label ?? "")
        validation.setFieldValue("contentTopic1EmailList", resData?.contentTopic1EmailList ?? "")

        validation.setFieldValue("contentTopic2Label", resData?.contentTopic2Label ?? "")
        validation.setFieldValue("contentTopic2EmailList", resData?.contentTopic2EmailList ?? "")

        validation.setFieldValue("contentTopic3Label", resData?.contentTopic3Label ?? "")
        validation.setFieldValue("contentTopic3EmailList", resData?.contentTopic3EmailList ?? "")

        validation.setFieldValue("contentTopic4Label", resData?.contentTopic4Label ?? "")
        validation.setFieldValue("contentTopic4EmailList", resData?.contentTopic4EmailList ?? "")

        validation.setFieldValue("contentTopic5Label", resData?.contentTopic5Label ?? "")
        validation.setFieldValue("contentTopic5EmailList", resData?.contentTopic5EmailList ?? "")

        validation.setFieldValue("contentTopic6Label", resData?.contentTopic6Label ?? "")
        validation.setFieldValue("contentTopic6EmailList", resData?.contentTopic6EmailList ?? "")

        // console.log('resData.attachmentList.find(obj => obj.contentAttachmentList == "banner_desktop"', resData.contentAttachmentList.find(obj => obj.attachmentField == "banner_desktop"))

        validation.setFieldValue(
            "bannerDesktop",
            resData?.contentBannerDesktop ?? ""
        )
        validation.setFieldValue(
            "bannerMobile",
            resData?.contentBannerMobile ?? ""
        )

        validation.setFieldValue(
            "socialLink",
            resData?.contentSocialLink ?? []
        )

        validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
        validation.setFieldValue(
            "contentSeoKeyword",
            resData?.contentSeoKeyword ?? ""
        )
        validation.setFieldValue(
            "contentSeoDescription",
            resData?.contentSeoDescription ?? ""
        )

        validation.setFieldValue(
            "contentUpdateDate",
            resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "contentStatus",
            resData?.contentStatus ?? "active"
        )
    }

    const API = {

        //         const response = await SearchPageSetting(componentKey, {
        //             lang: qLang,
        //         })
        //         const resData = response.data
        //         if (resData.status == 200) {
        //             preFilInputPage(resData.data)
        //         }
        //     } catch (err) {
        //         console.log("err ", err)
        //         mAlert.info({
        //             title: "Alert",
        //             subTitle: "Something went wrong 001",
        //             content: "",
        //             onClose: () => {
        //                 //  alert("onClose")
        //             },
        //         })
        //     } finally {
        //         setContentLoading(false)
        //     }
        // },
        fetchGetContentById: async payload => {
            try {
                const response = await GetContentById({
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload, pageSettingRoute) => {
            try {
                const responseP = await SavePageSetting(componentKey, { data: pageSettingRoute, lang: qLang })
                const resDataP = responseP.data
                const response = await CreateContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201 && resDataP.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContent: async (payload, pageSettingRoute) => {
            try {
                const responseP = await UpdatePageSetting(componentKey, { data: pageSettingRoute, lang: qLang })
                const resDataP = responseP.data
                const response = await UpdateContent({
                    data: payload,
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 202 && resDataP.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)
            API.fetchGetContentById(payload)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: "10px",
        border: "1px solid black",
        margin: "5px",
        borderRadius: "8px",
        background: "#f9f9f9",
        transition: "transform 0.2s ease, background-color 0.3s ease",
    }

    const mapValues = (list = []) =>
        list.map(item => {
            const newObj = {
                attachmentId: item.attachmentId,
                sequence: item.sequence,
            }
            return newObj
        })
    
    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {contentLoading ? (
                        <Spinners setLoading={setContentLoading} />
                    ) : (
                        <Row>
                            <Col className="col-12">
                                <FormikProvider value={validation}>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col className="col-8">
                                                <Row>
                                                    <Col className="col-12">
                                                        <Card>
                                                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                                <i className="bx bx-cube-alt"></i> {pageName}
                                                            </h5>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="contentName"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Page Name
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="contentName"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="contentName"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "contentName",
                                                                                        e.target.value
                                                                                    )
                                                                                    validation.setFieldValue(
                                                                                        "contentSeoTitle",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.contentName}
                                                                                invalid={
                                                                                    validation.touched.contentName &&
                                                                                        validation.errors.contentName
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.contentName &&
                                                                                validation.errors.contentName && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.contentName}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="slug"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Slug
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="slug"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="slug"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "slug",
                                                                                        slugify(e.target.value)
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.slug}
                                                                                invalid={
                                                                                    validation.touched.slug &&
                                                                                        validation.errors.slug
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.slug &&
                                                                                validation.errors.slug && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.slug}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="contentDetail"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Detail
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <MyEditor
                                                                                id="contentDetail"
                                                                                placeholder=""
                                                                                name="contentDetail"
                                                                                onChange={(e, editor) => {
                                                                                    const data = editor.getData()
                                                                                    validation.setFieldValue(
                                                                                        "contentDetail",
                                                                                        data
                                                                                    )
                                                                                    console.log({ e, editor, data })
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.contentDetail}
                                                                                invalid={
                                                                                    validation.touched.contentDetail &&
                                                                                        validation.errors.contentDetail
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                                isError={
                                                                                    validation.touched.contentDetail &&
                                                                                        validation.errors.contentDetail
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-6 mb-3">
                                                                        {/* {JSON.stringify(validation.values.bannerDesktop)} */}
                                                                        <div className="col-md-12">
                                                                            <PopupAttachment
                                                                                typeDetail="single"
                                                                                typeUpload="ImageMap"
                                                                                upload="Image"
                                                                                prefixName="banner-desktop"
                                                                                label="Banner Desktop"
                                                                                required={true}
                                                                                description="description"
                                                                                widthSize={2160}
                                                                                heightSize={990}
                                                                                value={validation.values.bannerDesktop}
                                                                                onChange={(value = {}, index) => {
                                                                                    console.log("🚀 onChange ~ value:", value)
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerDesktop', value)
                                                                                }}
                                                                                onRemove={(index) => {
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerDesktop', {})
                                                                                }}
                                                                            />
                                                                            {validation.touched.bannerDesktop && validation.errors.bannerDesktop && (
                                                                                <div type="invalid" className="invalid-feedback d-block">
                                                                                    {validation.errors.bannerDesktop}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-6 mb-3">
                                                                        {/* {JSON.stringify(validation.values.bannerMobile)} */}
                                                                        <div className="col-md-12">
                                                                            <PopupAttachment
                                                                                typeDetail="single"
                                                                                typeUpload="ImageMap"
                                                                                upload="Image"
                                                                                prefixName="banner-mobile"
                                                                                label="Banner Mobile"
                                                                                required={true}
                                                                                description="description"
                                                                                widthSize={540}
                                                                                heightSize={780}
                                                                                value={validation.values.bannerMobile}
                                                                                onChange={(value = {}, index) => {
                                                                                    console.log("🚀 onChange ~ value:", value)
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerMobile', value)
                                                                                }}
                                                                                onRemove={(index) => {
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerMobile', {})
                                                                                }}
                                                                            />
                                                                            {validation.touched.bannerMobile && validation.errors.bannerMobile && (
                                                                                <div type="invalid" className="invalid-feedback d-block">
                                                                                    {validation.errors.bannerMobile}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        {/* {JSON.stringify(validation.values.socialLink)} */}
                                                                        <div className="col-md-12">
                                                                            <UploadDesc
                                                                                upload="Image"
                                                                                typeUpload="ImageMap"
                                                                                label="Social Link"
                                                                                required={true}
                                                                                widthSize={35}
                                                                                heightSize={35}
                                                                                description="description"
                                                                            />
                                                                            <section className="b-upload-list">
                                                                                <ReactSortable
                                                                                    list={validation.values.socialLink} // ผูกข้อมูลกับค่าใน Formik
                                                                                    setList={(newState) => {
                                                                                        console.log('สถานะใหม่:', newState);
                                                                                        const newStateSort = fn_helper.FNFORM.setReSequence(newState)
                                                                                        validation.setFieldValue('socialLink', newStateSort); // อัพเดตค่าฟอร์ม
                                                                                    }}
                                                                                    animation={200}
                                                                                    handle=".drag-handle" // จุดที่สามารถลากได้
                                                                                    onEnd={() => {
                                                                                        console.log('ลากและปล่อยเสร็จสิ้น');
                                                                                        // validation.validateField('socialLink'); // ตรวจสอบความถูกต้องของฟิลด์
                                                                                    }}
                                                                                >
                                                                                    <FieldArray name="socialLink">
                                                                                        {({ push, remove }) => (
                                                                                            <>
                                                                                                {
                                                                                                    validation.values.socialLink.map((row, index) => {
                                                                                                        return (
                                                                                                            <div className="drag-handle" key={index}>
                                                                                                                <PopupAttachment
                                                                                                                    isShowLabel={false}
                                                                                                                    typeDetail="muti"
                                                                                                                    typeUpload="ImageMap"
                                                                                                                    upload="Image"
                                                                                                                    prefixName="brand-image"
                                                                                                                    label="Social Link"
                                                                                                                    required={true}
                                                                                                                    description="description"
                                                                                                                    widthSize={35}
                                                                                                                    heightSize={35}
                                                                                                                    value={row}
                                                                                                                    index={index}
                                                                                                                    mode="ImageLink"
                                                                                                                    onChange={(value = {}, index) => {
                                                                                                                        console.log("🚀 onChange ~ value:", value)
                                                                                                                        console.log("🚀 onChange ~ index:", index)
                                                                                                                        const name = `socialLink.${index}`
                                                                                                                        validation.setFieldValue(name, value)
                                                                                                                        // customHandleChange(e, index)
                                                                                                                        // push(value)
                                                                                                                    }}
                                                                                                                    onRemove={(index) => {
                                                                                                                        console.log("🚀 onChange ~ index:", index)
                                                                                                                        remove(index)
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                                <PopupAttachment
                                                                                                    isAddMode={true}
                                                                                                    isShowLabel={false}
                                                                                                    typeDetail="muti"
                                                                                                    typeUpload="ImageMap"
                                                                                                    upload="Image"
                                                                                                    prefixName="brand-image"
                                                                                                    label="Social Link"
                                                                                                    required={true}
                                                                                                    description="description"
                                                                                                    widthSize={35}
                                                                                                    heightSize={35}
                                                                                                    index={validation.values.socialLink.length}
                                                                                                    // mode="ImageLink"
                                                                                                    mode="ImageLink"
                                                                                                    onChange={(value = {}, index) => {
                                                                                                        console.log("🚀 onChange ~ value:", value)
                                                                                                        console.log("🚀 onChange ~ index:", index)
                                                                                                        push(value)
                                                                                                    }}
                                                                                                    onRemove={(index) => {
                                                                                                        console.log("🚀 onChange ~ index:", index)
                                                                                                        remove(index)
                                                                                                    }}
                                                                                                />
                                                                                            </>
                                                                                        )}
                                                                                    </FieldArray>
                                                                                </ReactSortable>
                                                                            </section>

                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                </Row>
                                                                {/* <Row id="sort-card">
                                                                { cardSeq.map((itemNo, index) => {
                                                                    return <CardPieceTopic key={itemNo} runningNo={index+1} pageView={pageView} validation={validation} cardNumber={itemNo}/>
                                                                })}
                                                                </Row> */}
                                                                <ReactSortable
                                                                    list={cardSeq}
                                                                    setList={handleSortEnd}
                                                                    animation={150}
                                                                    id="sort-card"
                                                                    className="row"
                                                                    handle=".drag-handle"
                                                                >
                                                                    {cardSeq.map((itemNo, index) => (
                                                                        <CardPieceTopic
                                                                            key={itemNo} // Unique key to prevent unnecessary re-renders
                                                                            runningNo={index + 1}
                                                                            pageView={pageView}
                                                                            validation={validation}  // Passing Formik validation
                                                                            cardNumber={itemNo}
                                                                        />
                                                                    ))}
                                                                </ReactSortable>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col className="col-4">
                                                <Card
                                                    outline
                                                    color="primary"
                                                    className="border sticky-element"
                                                >
                                                    <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                        <i className="bx bx-check"></i> Tools Box
                                                    </h5>
                                                    <CardBody>
                                                        <Row>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Switch Language
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputLang
                                                                        widthfull
                                                                        pageView={pageView}
                                                                        forceRoute={false}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Written at
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputGroup>
                                                                        <Flatpickr
                                                                            className="form-control d-block"
                                                                            options={{
                                                                                dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                            }}
                                                                            value={
                                                                                validation.values.contentUpdateDate
                                                                                    ? moment(
                                                                                        validation.values
                                                                                            .contentUpdateDate,
                                                                                        "YYYY-MM-DD"
                                                                                    ).toDate()
                                                                                    : null
                                                                            }
                                                                            disabled={true}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                disabled
                                                                            >
                                                                                <i
                                                                                    className="fa fa-calendar"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </InputGroup>
                                                                    {validation.touched.contentUpdateDate &&
                                                                        validation.errors.contentUpdateDate && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentUpdateDate}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <Input type="hidden" value="active" />
                                                                {/* <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Display
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Select
                                                                        placeholder="Select Status"
                                                                        value={fn_helper.FNFORM.getObjectValue(
                                                                            STATUS_OPTION,
                                                                            `${validation.values.contentStatus}`
                                                                        )}
                                                                        onChange={value =>
                                                                            validation.setFieldValue(
                                                                                "contentStatus",
                                                                                value.id
                                                                            )
                                                                        }
                                                                        getOptionValue={option => option.id}
                                                                        getOptionLabel={option => option.name}
                                                                        options={STATUS_OPTION}
                                                                        className={`select2-selection ${validation.touched.contentStatus &&
                                                                                validation.errors.contentStatus
                                                                                ? "input-err"
                                                                                : ""
                                                                            }`}
                                                                        isDisabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentStatus &&
                                                                        validation.errors.contentStatus && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentStatus}
                                                                            </div>
                                                                        )}
                                                                </div> */}
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                    <CardFooter>
                                                        <Row>
                                                            {/* <Col className="text-start">
                                                                <Button
                                                                    color="danger"
                                                                    className="btn btn-danger"
                                                                    onClick={() =>
                                                                        navigate(`/${_routeLink}/${qLang}`)
                                                                    }
                                                                >
                                                                    Back
                                                                </Button>
                                                            </Col> */}
                                                            <Col className="text-end">
                                                                {pageView !== "view" && (
                                                                    <Button
                                                                        type="submit"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Save{" "}
                                                                        {waitSendData ? (
                                                                            <Spinner size="sm" color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                            <Col className="col-12">
                                                <Card>
                                                    <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                        <i className="bx bx-trending-up"></i> SEO Box
                                                    </h5>
                                                    <CardBody>
                                                        <Row className="">
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Meta Title
                                                                    {/* <span className="t-require">*</span> */}
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Input
                                                                        id="contentSeoTitle"
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="Page Title"
                                                                        name="contentSeoTitle"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.contentSeoTitle}
                                                                        invalid={
                                                                            validation.touched.contentSeoTitle &&
                                                                                validation.errors.contentSeoTitle
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        disabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentSeoTitle &&
                                                                        validation.errors.contentSeoTitle && (
                                                                            <FormFeedback type="invalid">
                                                                                {validation.errors.contentSeoTitle}
                                                                            </FormFeedback>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Meta Description
                                                                    {/* <span className="t-require">*</span> */}
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Input
                                                                        id="contentSeoDescription"
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="SEO Description"
                                                                        name="contentSeoDescription"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={
                                                                            validation.values.contentSeoDescription
                                                                        }
                                                                        invalid={
                                                                            validation.touched
                                                                                .contentSeoDescription &&
                                                                                validation.errors.contentSeoDescription
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        disabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentSeoDescription &&
                                                                        validation.errors.contentSeoDescription && (
                                                                            <FormFeedback type="invalid">
                                                                                {
                                                                                    validation.errors
                                                                                        .contentSeoDescription
                                                                                }
                                                                            </FormFeedback>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Meta Keywords
                                                                    {/* <span className="t-require">*</span> */}
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Input
                                                                        id="contentSeoKeyword"
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="SEO Keywords"
                                                                        name="contentSeoKeyword"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.contentSeoKeyword}
                                                                        invalid={
                                                                            validation.touched.contentSeoKeyword &&
                                                                                validation.errors.contentSeoKeyword
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        disabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentSeoKeyword &&
                                                                        validation.errors.contentSeoKeyword && (
                                                                            <FormFeedback type="invalid">
                                                                                {validation.errors.contentSeoKeyword}
                                                                            </FormFeedback>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormikProvider>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(ContactUsTemplate)
